// track.js — PostHog click events for the marketing page CTAs.
// Only visitors who aren't signed in are counted: ProfileProvider identifies
// signed-in users, which sets PostHog's $user_id.
// Every event carries time_on_page_s. Each visit sends home_page_exited once —
// the first time the tab is hidden or the visitor leaves the page — with
// cta_clicked telling whether any CTA was clicked before that.
import posthog, { isPostHogConfigured } from '../../posthog'

let arrival = Date.now()
let ctaClicked = false
let exitSent = false

const timeOnPageS = () => Math.round((Date.now() - arrival) / 1000)

const capture = (event, properties) => {
	if (!isPostHogConfigured) return
	if (posthog.get_property('$user_id')) return
	posthog.capture(event, { ...properties, time_on_page_s: timeOnPageS() })
}

const track = (event, location, label) => {
	ctaClicked = true
	capture(event, { location, label })
}

let pendingExit = null

const sendExit = () => {
	if (exitSent) return
	exitSent = true
	capture('home_page_exited', { cta_clicked: ctaClicked })
}

// Call on home page mount; returns the cleanup for unmount.
export const startHomeVisit = () => {
	// StrictMode remounts immediately in dev — that isn't an exit.
	clearTimeout(pendingExit)
	arrival = Date.now()
	ctaClicked = false
	exitSent = false
	const onVisibility = () => {
		if (document.visibilityState === 'hidden') sendExit()
	}
	document.addEventListener('visibilitychange', onVisibility)
	return () => {
		document.removeEventListener('visibilitychange', onVisibility)
		pendingExit = setTimeout(sendExit, 0)
	}
}

export const trackLoginClick = (location) => () => track('home_login_clicked', location, 'Log in')
export const trackGetStartedClick = (location, label) => () => track('home_get_started_clicked', location, label)
export const trackBookDemoClick = (location) => () => track('home_book_demo_clicked', location, 'Book a demo')
